






























































































































import { Component } from 'vue-property-decorator';
import { PersonModule } from '@/store/Customers/PersonModule';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import PersonEdit from '@/components/Customers/People/PersonEdit.vue';

@Component({ name: 'PersonDetails', components: { PersonEdit } })
export default class extends SaascadaVue {

    get person() {
        return PersonModule.person;
    }

}
